import { scenarioAnswerValueTypes, scenarioQuestionTypes } from "helpers/enums";
import { enumLabel } from "helpers/system";
import React from "react";
import AnswerOptions from "./scenarioAnswerOptions";

const ShowScenarioQuestion = (scenarioQuestion) => {
    const {
        id,
        text,
        questionType,
        answerValueType,
        maxValueCondition,
        minValueCondition,
        answerOptions,
        questionOptions,
        nextQuestionId,
        externalData,
    } = scenarioQuestion;
    return (
        <div className="answer__card">
            <div className="answer__card--number">
                <h6>#{id}</h6>
            </div>
            <div className="answer__card--body">
                <h6>{text}</h6>
                <div className="answer__card-body">
                    <strong className="text-muted">Тип вопроса:&nbsp;</strong>
                    <div className="answer__card-body--value">{enumLabel(scenarioQuestionTypes, questionType)}</div>
                    <strong className="text-muted">PropertyName:&nbsp;</strong>
                    <div className="answer__card-body--value">{externalData?.propertyName || "—"}</div>
                    {answerValueType && (
                        <>
                            <strong className="text-muted">Тип вопроса:&nbsp;</strong>
                            <div className="answer__card-body--value">
                                {enumLabel(scenarioAnswerValueTypes, answerValueType)}
                            </div>
                        </>
                    )}
                    {minValueCondition !== null && (
                        <>
                            <strong className="text-muted">Минимальное значение:&nbsp;</strong>
                            <div className="answer__card-body--value">{minValueCondition}</div>
                        </>
                    )}
                    {maxValueCondition !== null && (
                        <>
                            <strong className="text-muted">Максимальное значение:&nbsp;</strong>
                            <div className="answer__card-body--value">{maxValueCondition}</div>
                        </>
                    )}
                    {answerOptions && answerOptions.length > 0 && (
                        <>
                            <strong className="text-muted">Варианты ответов:&nbsp;</strong>
                            <AnswerOptions scenarioQuestion={scenarioQuestion} questionOptions={questionOptions} />
                        </>
                    )}
                    {nextQuestionId && (
                        <>
                            <strong className="text-muted">Следующий вопрос:&nbsp;</strong>
                            <div className="answer__card-body--value">{enumLabel(questionOptions, nextQuestionId)}</div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ShowScenarioQuestion;
